import { auth } from '../constants/auth.constant';

export const authHandle = (isAuth) => (isAuth === auth.true ? 'Logueado' : 'No logueado');
